document.addEventListener('DOMContentLoaded', e => {

    const searchForms = document.querySelectorAll('.search-form');
    searchForms.forEach(searchForm => {
        const searchInput = searchForm.querySelector('.search-form__input');
        const searchResult = searchForm.querySelector('.search-form__result');
        let timeout = null;
        let isLoading = false;

        const performSearch = () => {
            const query = searchInput.value;

            if (query.length < 2) {
                searchResult.innerHTML = '';
                searchResult.classList.remove('show');
                return;
            }

            isLoading = true;
            searchForm.classList.add('loading');

            const formData = new FormData();
            formData.append('action', 'kitan_search_products');
            formData.append('s', query);
            formData.append('nonce', main.nonce);

            fetch(main.ajaxUrl, {
                method: 'POST',
                body: formData
            })
                .then(response => response.json())
                .then(data => {
                    if (data.success) {
                        searchResult.innerHTML = data.data.html;
                        searchResult.classList.add('show');
                    }
                })
                .catch(error => console.error('Error:', error))
                .finally(() => {
                    searchForm.classList.remove('loading');
                    isLoading = false;
                });
        };

        document.addEventListener('click', (e) => {
            if (!searchForm.contains(e.target)) {
                searchResult.classList.remove('show');
            }
        });

        searchInput.addEventListener('input', () => {
            clearTimeout(timeout);
            timeout = setTimeout(performSearch, 500);
        });

        // searchForm.addEventListener('submit', (e) => {
        //     e.preventDefault();
        //     clearTimeout(timeout);
        //     performSearch();
        // });
    });
});
